import reminderAlertUrl from '@/assets/misc/img_reminder-alert.svg'
import { observer } from 'mobx-react-lite'
import {
  ModalDialog,
  ModalDialogActions,
  ModalDialogContent,
  ModalDialogDescription,
  ModalDialogFooter,
  ModalDialogHeader,
  ModalDialogTitle,
} from '@/components/ModalDialog'
import { Button } from '@/components/Button'
import type { ConnectWithProDialogViewModel } from './ConnectWithProDialogViewModel'

export { ConnectWithProDialogViewModel } from './ConnectWithProDialogViewModel'

interface ConnectWithProDialogProps {
  vm: ConnectWithProDialogViewModel
  testId?: string
}

export const ConnectWithProDialog = observer(function ConnectWithProDialog({
  vm,
  testId,
}: ConnectWithProDialogProps) {
  const isConfirming = vm.confirm.pending

  return (
    <ModalDialog
      isOpen={vm.modal.showing}
      onClose={vm.closeDialog}
      isDismissable={!isConfirming}
      testId={testId}
    >
      <ModalDialogHeader>
        <ModalDialogTitle>
          <img src={reminderAlertUrl} alt="Reminder Alert" aria-hidden />
        </ModalDialogTitle>
      </ModalDialogHeader>
      <ModalDialogContent>
        <ModalDialogTitle>Ready to connect with your Pro?</ModalDialogTitle>
        <ModalDialogDescription>
          Your Pro will use your documents and questionnaire answers to prepare
          your return. The more complete, the faster it goes.
        </ModalDialogDescription>
      </ModalDialogContent>
      <ModalDialogFooter sticky bordered compact>
        <ModalDialogActions>
          <Button
            label="Connect with a Pro"
            variant="default"
            onPress={vm.confirm}
            isPending={isConfirming}
            testId={testId ? `${testId}-connect-button` : undefined}
          />
          <Button
            label="Go back and check"
            variant="outline"
            onPress={vm.closeDialog}
            isDisabled={isConfirming}
            testId={testId ? `${testId}-cancel-button` : undefined}
          />
        </ModalDialogActions>
      </ModalDialogFooter>
    </ModalDialog>
  )
})
